import { BrowserRouter, Route, Routes} from "react-router-dom"
import { routes  as authRoutes } from "./auth/Auth"
import { routes  as dataRoutes } from "./data/DataVisualization"
import { PrivateRoute } from "./private-route/PrivateRoute";
import { PublicRoute } from "./public-routes/PublicRoutes";
import { AuthProvider } from "@/contexts/auth/Auth";

const routes = [
    ...authRoutes,
    ...dataRoutes
];

export const Router = () => {
  
    return (
      <BrowserRouter>
        <AuthProvider>
          <Routes>
                  {routes.map((route) => (
                    <Route
                      element={route.isPublic ? 
                      <PublicRoute>{route.element}</PublicRoute> :
                        <PrivateRoute>{route.element}</PrivateRoute>              
                      }
                      key={route.path}
                      path={route.path}
                    />
                  ))}
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    );
  };
  